import type { IsoDate } from '../../domain/dates';
import type { AppData } from './app-data';
import { createPlan, editPlan, type EditResult, type PlanEdit } from './plan-service';

/**
 * DE: Rechenaufträge, die im Hintergrund laufen können: Plan erstellen oder ändern.
 * EN: Calculation jobs that can run in the background: create or change a plan.
 */
export type PlanJob =
  | { kind: 'create'; data: AppData; options: Parameters<typeof createPlan>[1] }
  | { kind: 'edit'; data: AppData; today: IsoDate; edit: PlanEdit };

export interface PlanRequestMessage {
  id: number;
  job: PlanJob;
}

export type PlanAnswerMessage = { id: number; result: EditResult } | { id: number; error: string };

/**
 * DE: Auftrag ausführen; ein neuer Plan kommt in derselben Form wie eine Änderung zurück.
 * EN: Run a job; a new plan comes back in the same shape as a change.
 */
export function runPlanJob(job: PlanJob): EditResult {
  switch (job.kind) {
    case 'create':
      return { stored: createPlan(job.data, job.options) };
    case 'edit':
      return editPlan(job.data, job.today, job.edit);
  }
}

/**
 * DE: Antwort auf eine Nachricht; Fehler werden als Text zurückgegeben statt geworfen.
 * EN: Answer to a message; errors are returned as text instead of thrown.
 */
export function answerPlanJob(message: PlanRequestMessage): PlanAnswerMessage {
  try {
    return { id: message.id, result: runPlanJob(message.job) };
  } catch (error) {
    return { id: message.id, error: error instanceof Error ? error.message : String(error) };
  }
}
